import { CONTACTS, EDA_URL, EDARU_URL, FLEET_URL } from './constants.js'

export const MEDIA_ORIGIN = 'https://images.vsevsetaksi.ru'

export const mediaAssets = Object.freeze({
  avatar: {
    src: `${MEDIA_ORIGIN}/lena/lena-avatar-2026-v1.webp`,
    width: 640,
    height: 640,
    alt: 'Лена, проводник ABG Taxi и Едару',
    position: '50% 42%',
  },
  courier: {
    src: `${MEDIA_ORIGIN}/lena/lena-courier-wide-2026-v1.webp`,
    width: 1600,
    height: 901,
    alt: 'Лена рассказывает о работе в доставке',
    position: '50% 45%',
  },
  payout: {
    src: `${MEDIA_ORIGIN}/lena/lena-payout-phone-16x9-2026-v1.webp`,
    width: 1280,
    height: 720,
    alt: 'Лена показывает инструкцию по выплатам в Яндекс Про',
    position: '50% 50%',
  },
  taxiSpb: {
    src: `${MEDIA_ORIGIN}/lena/lena-taxi-spb-wink-2026-v1.webp`,
    width: 1672,
    height: 941,
    alt: 'Лена в припаркованном автомобиле в Санкт-Петербурге',
    position: '52% 50%',
  },
  taxiMoscow: {
    src: `${MEDIA_ORIGIN}/lena/lena-taxi-moscow-phone-2026-v1.webp`,
    width: 1448,
    height: 1086,
    alt: 'Лена проверяет телефон в припаркованном автомобиле',
    position: '50% 48%',
  },
  oneStep: {
    src: `${MEDIA_ORIGIN}/lena/lena-one-step-2026-v1.webp`,
    width: 1536,
    height: 1024,
    alt: 'Лена показывает один понятный следующий шаг',
    position: '50% 43%',
  },
  profileCheck: {
    src: `${MEDIA_ORIGIN}/lena/lena-profile-check-2026-v1.webp`,
    width: 1536,
    height: 1024,
    alt: 'Лена проверяет профиль на телефоне в припаркованной машине',
    position: '50% 46%',
  },
  routeMap: {
    src: `${MEDIA_ORIGIN}/lena/lena-route-map-2026-v1.webp`,
    width: 1536,
    height: 1024,
    alt: 'Лена сверяет район доставки с картой рядом с велосипедом',
    position: '50% 46%',
  },
  documents: {
    src: `${MEDIA_ORIGIN}/lena/lena-documents-2026-v1.webp`,
    width: 1448,
    height: 1086,
    alt: 'Лена проверяет нейтральный список документов перед анкетой',
    position: '50% 44%',
  },
  troubleshoot: {
    src: `${MEDIA_ORIGIN}/lena/lena-troubleshoot-2026-v1.webp`,
    width: 1536,
    height: 1024,
    alt: 'Лена спокойно объясняет, что проверить при затруднении',
    position: '50% 42%',
  },
  nextRoute: {
    src: `${MEDIA_ORIGIN}/lena/lena-next-route-2026-v1.webp`,
    width: 1600,
    height: 900,
    alt: 'Лена показывает направление рядом с машиной и курьерской сумкой',
    position: '50% 48%',
  },
})

export const payoutVideo = Object.freeze({
  src: `${MEDIA_ORIGIN}/video/kak-vyvesti-dengi-yandex-pro-2026-v1.mp4`,
  poster: mediaAssets.payout.src,
  width: 1280,
  height: 720,
  duration: 'PT3M6S',
  uploadDate: '2026-08-03',
  youtube: 'https://youtu.be/YoindsarmhA',
  vk: 'https://vkvideo.ru/video-196018683_456239071',
})

export const lenaGuides = Object.freeze({
  '/alex': {
    asset: mediaAssets.courier,
    quote: 'Я помогу не потеряться после анкеты: тот же номер, нужный профиль, проверки и только потом первый заказ.',
    href: '#alex-after-title',
    label: 'Показать шаги после анкеты',
  },
  '/': {
    asset: mediaAssets.taxiSpb,
    quote: 'Сначала выбери маршрут: за руль или в доставку. Дальше разберём документы и первый выход по шагам.',
  },
  '/taxi': {
    asset: mediaAssets.taxiMoscow,
    quote: 'Я бы не начинала с обещанной суммы. Сначала проверь документы, автомобиль и сколько будет стоить твоя смена.',
    href: '/instructions/yandex-pro',
    label: 'Открыть инструкцию Яндекс Про',
  },
  '/dostavka': {
    asset: mediaAssets.courier,
    quote: 'Сначала подберём анкету: с самозанятостью и без неё условия разные. После подключения покажу, где выбрать парк и что проверить перед заказом.',
    href: '#registration',
    label: 'Выбрать анкету Доставки',
  },
  '/podrabotka': {
    asset: mediaAssets.avatar,
    quote: 'Если деньги нужны сейчас, выбери смену, после которой останутся силы и понятный результат.',
    href: '/dostavka',
    label: 'Выбрать анкету Доставки',
  },
  '/eda': {
    asset: mediaAssets.courier,
    quote: 'Начни с транспорта, который уже есть. Первый выход должен показать тебе район, приложение и реальные расходы — не требовать новой покупки.',
    href: 'https://edaru.su/blog/chto-delat-posle-registracii-yandeks-eda-2026',
    label: 'Что делать после регистрации',
  },
  '/kuper': {
    asset: mediaAssets.routeMap,
    quote: 'Я сравниваю не логотипы, а один и тот же вечер: сколько ехать до зоны, на чём доставлять, когда придут деньги и что останется после расходов.',
    href: 'https://edaru.su/blog/eda-vs-kuper-2026',
    label: 'Почему мы советуем Яндекс Еду',
  },
  '/rabota': {
    asset: mediaAssets.taxiMoscow,
    quote: 'Если есть машина, сравни такси и доставку. Если транспорта нет, начни пешком. Не выбирай профессию по чужой красивой смене.',
    href: '/podrabotka',
    label: 'Начать с тестовой смены',
  },
  '/instructions': {
    asset: mediaAssets.payout,
    quote: 'Выбери, что случилось именно у тебя. Я покажу, что проверить самому и когда писать парку или поддержке сервиса.',
    href: '/instructions/yandex-pro',
    label: 'Проверить Яндекс Про',
  },
  '/instructions/yandex-pro': {
    asset: mediaAssets.payout,
    quote: 'Перед линией проверь профиль. Если деньги уже на балансе, ниже покажу, как вывести их без догадок.',
    href: '#payout-video',
    label: 'Показать вывод денег',
  },
  '/uz': {
    asset: mediaAssets.avatar,
    quote: 'Avval shahar, avtomobil va hujjatlarni tekshiring. Keyin anketani xatosiz to‘ldiring.',
    href: '/instructions/yandex-pro',
    label: 'Yandex Pro yo‘riqnomasi',
  },
  '/about': {
    asset: mediaAssets.avatar,
    quote: 'Парк помогает с подключением и профилем. Вопрос по принятому заказу быстрее решать в поддержке приложения.',
    href: '/instructions',
    label: 'Открыть инструкции',
  },
  '/offer': {
    asset: mediaAssets.avatar,
    quote: 'Перед отправкой анкеты проверь, кто оператор, какие данные нужны и куда обращаться по подключению.',
    href: '/about',
    label: 'Контакты и реквизиты',
    variant: 'legal',
  },
  '/privacy': {
    asset: mediaAssets.avatar,
    quote: 'Не отправляй в общий чат коды из SMS, CVV, пароли и полные фотографии документов.',
    href: '/about',
    label: 'Контакты оператора',
    variant: 'legal',
  },
})

export const lenaMoments = Object.freeze({
  '/alex': {
    checkpoint: {
      id: 'alex-check-application',
      role: 'checkpoint',
      asset: mediaAssets.oneStep,
      eyebrow: 'Лена · перед анкетой',
      title: 'Сначала проверь статус СМЗ',
      text: 'Эта анкета Александра рассчитана на самозанятых. Для такси заранее подготовь водительские документы и сведения об автомобиле, для Доставки — выбери свой транспорт.',
      action: { href: '#alex-route-title', label: 'Выбрать направление' },
    },
    next: {
      id: 'alex-first-day',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Лена · первый выход',
      title: 'Анкета отправлена — проверь профиль',
      text: 'Войди в Яндекс Про с тем же номером, найди нужный сервис и заверши проверки. Если профиль не появился, не создавай заявку-дубликат.',
      action: { href: '/instructions/yandex-pro', label: 'Проверить Яндекс Про' },
    },
  },
  '/': {
    checkpoint: {
      id: 'choose-from-what-you-have',
      role: 'checkpoint',
      asset: mediaAssets.oneStep,
      eyebrow: 'Подсказка Лены',
      title: 'Начни с того, что уже есть',
      text: 'Есть машина — смотри маршрут водителя. Хочешь начать без своей машины — сравни пешую, вело- и автодоставку. Документы и порядок действий покажем на следующей странице.',
      action: { href: '#route-heading', label: 'Сравнить два маршрута' },
    },
    next: {
      id: 'pick-test-format',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Не уверен — начни с тестового формата',
      text: 'Посмотри, сколько времени есть на смену, какой транспорт доступен и какие расходы появятся. Так проще выбрать маршрут без обещаний наугад.',
      action: { href: '/podrabotka', label: 'Подобрать формат подработки' },
    },
  },
  '/taxi': {
    checkpoint: {
      id: 'check-driver-profile',
      role: 'checkpoint',
      asset: mediaAssets.profileCheck,
      eyebrow: 'Подсказка Лены',
      title: 'До анкеты — две минуты на проверку',
      text: 'Я советую положить документы рядом до открытия анкеты. Город, автомобиль и водитель должны совпадать с тем, как ты действительно планируешь выходить на линию.',
      action: { href: '/instructions/yandex-pro', label: 'Проверить маршрут в Яндекс Про' },
    },
    next: {
      id: 'open-driver-form',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Всё готово? Переходи к анкете',
      text: 'Откроется официальная внешняя форма Fleet. После отправки вернись сюда: я проведу по профилю, первому выходу и выплатам в Яндекс Про.',
      action: { href: FLEET_URL, label: 'Есть СМЗ — открыть анкету водителя' },
    },
  },
  '/dostavka': {
    checkpoint: {
      id: 'choose-delivery-area',
      role: 'checkpoint',
      asset: mediaAssets.routeMap,
      eyebrow: 'Подсказка Лены',
      title: 'Район важнее красивого тарифа',
      text: 'Я бы сначала прошла маршрут мысленно: дорога до зоны, подъёмы, погода, парковка велосипеда или машины. Удобный транспорт в неподходящем районе не спасает смену.',
      action: { href: '#registration', label: 'Выбрать анкету Доставки' },
    },
    next: {
      id: 'open-courier-route',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Выбрал транспорт — можно подключаться',
      text: 'Осталось выбрать анкету с самозанятостью или без неё. Я покажу условия и три шага после подключения — всё на этой странице.',
      action: { href: '#registration', label: 'Выбрать анкету и начать' },
    },
  },
  '/podrabotka': {
    checkpoint: {
      id: 'plan-test-shift',
      role: 'checkpoint',
      asset: mediaAssets.oneStep,
      eyebrow: 'Подсказка Лены',
      title: 'Первую смену считай тестом',
      text: 'Заранее запиши время на дорогу, расходы и сумму после смены. Один честный тест даст больше, чем чужая история о заработке.',
      action: { href: '/rabota', label: 'Как оценить работу после смены' },
    },
    next: {
      id: 'choose-delivery-test',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Для короткого старта проще проверить доставку',
      text: 'Выбери пеший, велосипедный или автомобильный формат, проверь район и сохрани инструкцию на первый выход.',
      action: { href: '/dostavka', label: 'Выбрать анкету курьера' },
    },
  },
  '/eda': {
    checkpoint: {
      id: 'save-first-shift-plan',
      role: 'checkpoint',
      asset: mediaAssets.documents,
      eyebrow: 'Подсказка Лены',
      title: 'Сохрани не только анкету, но и следующий шаг',
      text: 'После регистрации запиши статус, проверь Яндекс Про и узнай, как получить нужную экипировку. Перед сменой останется выбрать знакомую зону, а не восстанавливать всё по сообщениям.',
      action: { href: `${EDARU_URL}/blog/chto-delat-posle-registracii-yandeks-eda-2026`, label: 'Открыть инструкцию первого выхода' },
    },
    next: {
      id: 'open-eda-registration',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Проверил транспорт и документы? Можно открывать анкету',
      text: 'Выбери город, укажи данные без сокращений и сохрани статус после отправки. Клик переводит на отдельную страницу оформления — перед вводом данных проверь адрес.',
      action: { href: EDA_URL, label: 'Проверить город и начать регистрацию' },
    },
  },
  '/kuper': {
    checkpoint: {
      id: 'compare-real-shift',
      role: 'checkpoint',
      asset: mediaAssets.routeMap,
      eyebrow: 'Подсказка Лены',
      title: 'Поставь оба сервиса в одинаковые условия',
      text: 'Возьми один район, одинаковые свободные часы и тот же транспорт. Потом сравни путь до смены, выплаты и остаток после расходов — так реклама не решит за тебя.',
      action: { href: `${EDARU_URL}/blog/eda-vs-kuper-2026`, label: 'Почему мы советуем Яндекс Еду' },
    },
    next: {
      id: 'choose-eda-route',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Нужен маршрут с понятным продолжением? Проверь Яндекс Еду',
      text: 'ABG помогает с подключением, а после анкеты у тебя останется инструкция по Яндекс Про, экипировке и первому выходу. Сначала проверь доступность для своего города.',
      action: { href: '/eda', label: 'Проверить маршрут Яндекс Еды' },
    },
  },
  '/rabota': {
    checkpoint: {
      id: 'count-shift-result',
      role: 'checkpoint',
      asset: mediaAssets.oneStep,
      eyebrow: 'Подсказка Лены',
      title: 'Сначала проверь одну рабочую гипотезу',
      text: 'Не меняй сразу сервис, район и транспорт. Возьми один формат на несколько похожих смен — тогда поймёшь, что принесло результат, а что съело время и деньги.',
      action: { href: '/podrabotka', label: 'Собрать план тестовой смены' },
    },
    next: {
      id: 'return-to-route-choice',
      role: 'next',
      asset: mediaAssets.nextRoute,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Выбери маршрут по тому, что уже есть',
      text: 'Автомобиль и документы ведут к сравнению такси и автодоставки. Без машины открой курьерский маршрут и начни с пешего или велосипедного формата.',
      action: { href: '/dostavka', label: 'Сравнить форматы доставки' },
    },
  },
  '/instructions': {
    checkpoint: {
      id: 'send-problem-to-right-place',
      role: 'checkpoint',
      asset: mediaAssets.troubleshoot,
      eyebrow: 'Подсказка Лены',
      title: 'Сначала определи, кто видит проблему',
      text: 'Я разделяю вопросы так: парк помогает с подключением и профилем, а поддержка сервиса видит активный заказ, маршрут и начисление. Выбери нужную сторону — не придётся объяснять всё дважды.',
      action: { href: '/about', label: 'Посмотреть границы помощи' },
    },
    next: {
      id: 'open-yandex-pro-guide',
      role: 'next',
      asset: mediaAssets.profileCheck,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Начни с профиля и баланса',
      text: 'Начни с профиля: город, транспорт, предупреждения и баланс. Ниже я собрала безопасный первый выход и видео вывода денег.',
      action: { href: '/instructions/yandex-pro', label: 'Открыть инструкцию Яндекс Про' },
    },
  },
  '/instructions/yandex-pro': {
    next: {
      id: 'ask-if-screen-differs',
      role: 'next',
      asset: mediaAssets.troubleshoot,
      eyebrow: 'Если экран выглядит иначе',
      title: 'Не отправляй коды и данные карты',
      text: 'Сделай скриншот без личных данных, укажи город и напиши, на каком шаге остановился. Парк проверит подключение и профиль; по активному заказу обращайся в поддержку приложения.',
      action: { href: CONTACTS.telegram, label: 'Написать парку в Telegram' },
    },
  },
  '/uz': {
    checkpoint: {
      id: 'check-uz-profile-data',
      role: 'checkpoint',
      asset: mediaAssets.documents,
      eyebrow: 'Lenaning maslahati',
      title: 'Anketadan oldin ma’lumotlarni tekshiring',
      text: 'Shahar, telefon, avtomobil va hujjatlardagi ism bir xil yozilgan bo‘lsin. SMS kodi, karta kodi yoki parolni chatga yubormang.',
      action: { href: FLEET_URL, label: 'Ulanish anketasini ochish' },
    },
    next: {
      id: 'open-uz-pro-guide',
      role: 'next',
      asset: mediaAssets.profileCheck,
      eyebrow: 'Keyingi qadam Lena bilan',
      title: 'Anketadan keyin Yandex Pro profilini tekshiring',
      text: 'Yo‘riqnoma rus tilida, lekin ekranlar bo‘yicha profil, balans va pul chiqarish tartibini ko‘rsatadi.',
      action: { href: '/instructions/yandex-pro', label: 'Yandex Pro yo‘riqnomasini ochish' },
    },
  },
  '/about': {
    checkpoint: {
      id: 'choose-support-channel',
      role: 'checkpoint',
      asset: mediaAssets.troubleshoot,
      eyebrow: 'Подсказка Лены',
      title: 'Напиши город и один точный вопрос',
      text: 'Для помощи с подключением укажи выбранный сервис и шаг, на котором остановился. По активному заказу безопаснее сразу писать в поддержку внутри приложения.',
      action: { href: CONTACTS.telegram, label: 'Написать парку в Telegram' },
    },
    next: {
      id: 'save-operator-contact',
      role: 'next',
      asset: mediaAssets.documents,
      eyebrow: 'Следующий шаг с Леной',
      title: 'Сохрани контакт перед регистрацией',
      text: 'Не пересылай в мессенджер пароли, SMS-коды, CVV и полные фотографии документов. Для обычного вопроса достаточно города, сервиса и скриншота без личных данных.',
      action: { href: CONTACTS.whatsapp, label: 'Открыть WhatsApp парка' },
    },
  },
  '/offer': {
    checkpoint: {
      id: 'clarify-offer-before-agreeing',
      role: 'checkpoint',
      asset: mediaAssets.documents,
      eyebrow: 'Пояснение Лены',
      title: 'Непонятный пункт лучше уточнить заранее',
      text: 'Сверь наименование оператора, реквизиты и способ связи. Если условие допускает разные толкования, задай вопрос до подтверждения.',
      action: { href: '/about', label: 'Контакты и реквизиты оператора' },
    },
  },
  '/privacy': {
    checkpoint: {
      id: 'protect-private-data',
      role: 'checkpoint',
      asset: mediaAssets.troubleshoot,
      eyebrow: 'Пояснение Лены',
      title: 'Часть данных нельзя отправлять в чат',
      text: 'Не пересылай пароли, SMS-коды, CVV и полные снимки документов. Для вопроса обычно достаточно города, сервиса и скриншота без личных данных.',
      action: { href: '/about', label: 'Контакты оператора данных' },
    },
  },
})

export function getLenaGuide(path) {
  return lenaGuides[path] || lenaGuides['/']
}
